"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfessionList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/layouts/default-layout/component");
const component_2 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="profession-list-page">
    <crud-table :isItemUneditable="${x => x.isProfessionUneditable}" :forceItemEditable="${x => x.forceProfessionEditable}" :onDataLoaded="${x => x.onDataLoaded}" title="${'profession.list.title'.t()}" addText="${'profession.create'.t()}" resource="onboarding" searchPlaceholder="${'profession.search.placeholder'.t()}"
      listEndpoint="profession.list" deleteEndpoint="profession.delete" queryParam="q"
      editRoute="/profession/form/:id" addRoute="/profession/form" :columns="${x => x.tableColumns}">
    </crud-table>
  </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.profession-list-page .branch-name {
  font-weight: 500;
  color: #495057;
}`;
const shadowOptions = { "mode": "open" };
let ProfessionList = class ProfessionList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tableColumns = [
            {
                key: 'name',
                header: 'profession.name'.t()
            },
            {
                key: 'description',
                header: 'profession.description'.t(),
                formatter: (description) => description || '-'
            },
            {
                key: 'branch',
                header: 'profession.branch'.t(),
                formatter: (branch) => {
                    if (!branch)
                        return '-';
                    return branch.name;
                }
            },
            {
                key: 'common',
                header: 'profession.common'.t(),
                formatter: (common) => `<span class="badge badge-${common ? 'success' : 'danger'}">` + (common ? 'profession.common.yes'.t() : 'profession.common.no'.t()) + '</span>'
            }
        ];
    }
    async connectedCallback() {
        var _a, _b, _c;
        const isSuperAdmin = ((_a = component_1.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        const isParentUser = ((_b = component_1.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_1.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
        if (!isSuperAdmin) {
            this.isProfessionUneditable = (row) => row.common === true;
            this.forceProfessionEditable = (row) => {
                var _a;
                if (!row.creator) {
                    return false;
                }
                return row.creator.id === ((_a = component_1.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.id);
            };
        }
        if (isParentUser || isSuperAdmin) {
            this.tableColumns.push({
                key: 'creator',
                header: 'profession.creator'.t(),
                formatter: (creator) => creator ? `<a class="creator-link" data-id="${creator.id}" href="/user/list/${creator.id}">${creator.name}</a>` : '-'
            });
            this.tableColumns.push({
                key: 'active',
                header: 'resource.active'.t(),
                formatter: (active) => `<span class="badge badge-${active || active === null || active === undefined ? 'success' : 'danger'}">${active || active === null || active === undefined ? 'Active' : 'Inactive'}</span>`
            });
        }
        super.connectedCallback();
    }
    onDataLoaded(data, totalPages, element) {
        if (data.length) {
            setTimeout(() => {
                const creators = element.shadowRoot.querySelectorAll('a.creator-link');
                creators.forEach(creator => {
                    creator.onclick = (e) => {
                        e.preventDefault();
                        component_2.SiteMenu.goto.bind(this)(`/user/list/${creator.dataset.id}`);
                    };
                });
            }, 0);
        }
    }
};
exports.ProfessionList = ProfessionList;
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], ProfessionList.prototype, "isProfessionUneditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], ProfessionList.prototype, "forceProfessionEditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ProfessionList.prototype, "tableColumns", void 0);
exports.ProfessionList = ProfessionList = __decorate([
    (0, client_1.RWSView)('profession-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ProfessionList);
ProfessionList.defineComponent();
